<template>
  <loader v-if="loading"/>
  <div v-else-if="isProcessing" class="processing-container">
    <div class="ri-medium-headline black-text center-text">
      קיבלנו את פרטי המשכנתא שלך -
      <span class="green-text">אנחנו על זה.</span>
    </div>
    <lottie-player
      src="/animations/mortgage-loader.json"
      autoplay
      loop
      class="mortgage-loader-animation margin-top-l"
    />
    <div class="ri-small-body black-text center-text margin-top-m">אנחנו בודקים מה המסלולים הכי מוצלחים בשבילך. זה עשוי לקחת כמה דקות.</div>
  </div>
  <mortgage-alternatives-page v-else-if="hasMortgageAlternatives" />
  <no-mortgage-data-alternatives-page v-else-if="mortgageFromCashflow" />
  <no-mortgage-page v-else />
</template>

<script>
import Segment from '@/Segment';
import BaseUI from '@riseupil/base-ui';
import { mapActions, mapGetters, mapState } from 'vuex';
import Loader from '@/base-components/Loader';
import mortgagesApi from '@/api/MortgagesApi';
import NoMortgagePage from '@/pages/responsive-pages/authenticated/navigation-pages/mortgages/NoMortgagePage.vue';
import MortgageAlternativesPage from './MortgageAlternativesPage.vue';
import NoMortgageDataAlternativesPage from './NoMortgageDataAlternativesPage.vue';

const POLL_INTERVAL_MS = 3000;

export default {
  name: 'MortgagePage',
  components: {
    NoMortgagePage,
    MortgageAlternativesPage,
    NoMortgageDataAlternativesPage,
    Loader,
    LottiePlayer: BaseUI.LottiePlayer,
  },
  data() {
    return {
      loading: true,
      isProcessing: false,
      pollingInterval: null,
    };
  },
  computed: {
    ...mapState('mortgages', ['mortgageFromCashflow']),
    ...mapGetters('mortgages', ['hasMortgageAlternatives']),
  },
  async created() {
    Segment.trackUserInteraction('MortgagePage_Entered');
    Segment.trackUserInteractionToPixel('existing_mortgage_results_pageViewed');

    const jobStatus = await mortgagesApi.getMortgageReportUploadStatus();
    if (jobStatus.status === 'PROCESSING') {
      this.isProcessing = true;
      this.loading = false;
      this.startProcessingPolling();
      this.fetchMortgageSimulations();
      return;
    }

    await this.fetchMortgageSimulations();
    this.loading = false;
  },
  beforeDestroy() {
    this.clearPolling();
  },
  methods: {
    ...mapActions('mortgages', ['fetchMortgageSimulations']),
    startProcessingPolling() {
      this.clearPolling();
      this.pollingInterval = setInterval(async () => {
        try {
          const result = await mortgagesApi.getMortgageReportUploadStatus();

          if (result.status === 'COMPLETED') {
            this.clearPolling();
            await this.fetchMortgageSimulations();
            this.isProcessing = false;
          } else if (result.status === 'FAILED') {
            this.clearPolling();
            this.isProcessing = false;
          }
        } catch (error) {
          console.error('Error polling mortgage report status', error);
        }
      }, POLL_INTERVAL_MS);
    },
    clearPolling() {
      if (this.pollingInterval) {
        clearInterval(this.pollingInterval);
        this.pollingInterval = null;
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@riseupil/base-ui/src/scss/riseup-colors";
@import "~@riseupil/base-ui/src/scss/spacings";

.cards-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.processing-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: $ri-spacing-ml;

  .green-text {
    color: $riseup_green;
    font-weight: 600;
  }

  .center-text {
    text-align: center;
  }

  .mortgage-loader-animation {
    width: 200px;
    height: 200px;
    transform: scale(1.2);
  }
}
</style>
